module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_01.8e517056.svg";